import React from 'react';
import TabBar from './tab_bar';

export default function VolumeTabBar(props) {
  const { style } = props;
  const list = [
    { value: 'detail', text: 'Detail', url: `/org` },
    { value: 'plan', text: 'Plan', url: `/org/plan` },
    { value: 'invoice', text: 'Invoices', url: `/org/invoice` },
    { value: 'payment', text: 'Payment Methods', url: `/org/payment` },
    { value: 'network', text: 'Network Stores', url: `/org/bucket` },
    { value: 'app', text: 'Apps', url: `/org/app` },
  ];
  return <TabBar style={style} list={list} />;
}
